import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { TwoFactorAuthComponent } from './components/two-factor-auth/two-factor-auth.component';
import { ContactAddressesComponent } from './components/contact-addresses/contact-addresses.component';
import { AddContactAddressComponent } from './components/contact-addresses/add/add.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { AddContactComponent } from './components/contacts/add/add.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { StateSelectComponent } from './components/state-select/state-select.component';
import { ErrorMessagePipe } from './pipes/error-message.pipe';
import { ViewonlySelectModeComponent } from './components/viewonly-select-mode/viewonly-select-mode.component';
import { AccessControlCardListComponent } from './components/access-control-card-list/access-control-card-list.component';
import { NumericfieldDirectiveModule } from './directives/numericfield.directive';
import { NgxMaskModule } from 'ngx-mask';
import { ErrorBarComponent } from './components/error-bar/error-bar.component';
import { EmailValidatorDirective } from './directives/email-validator.directive';
import { InformDialogComponent } from './components/inform-dialog/inform-dialog.component';
import { ContactMultiselectComponent } from './components/contact-multiselect/contact-multiselect.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [
    TwoFactorAuthComponent,
    ContactAddressesComponent,
    AddContactAddressComponent,
    ContactsComponent,
    AddContactComponent,
    ConfirmDialogComponent,
    StateSelectComponent,
    ErrorMessagePipe,
    ViewonlySelectModeComponent,
    AccessControlCardListComponent,
    ErrorBarComponent,
    EmailValidatorDirective,
    InformDialogComponent,
    ContactMultiselectComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    NumericfieldDirectiveModule,
    NgxMaskModule.forRoot(),
    NgSelectModule
  ],
  exports: [
    TwoFactorAuthComponent,
    ContactAddressesComponent,
    AddContactAddressComponent,
    ContactsComponent,
    AddContactComponent,
    ConfirmDialogComponent,
    StateSelectComponent,
    ErrorMessagePipe,
    ViewonlySelectModeComponent,
    AccessControlCardListComponent,
    ErrorBarComponent,
    EmailValidatorDirective,
    ContactMultiselectComponent
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {},
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        enterAnimationDuration: 150
      } as MatDialogConfig
    }
  ],
})
export class SharedModule {}
